import { useCallback, useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";

import { FullHeightLoader } from "../../components/Loader/FullHeightLoader";
import {
  PlayoffProvider,
  usePlayoffContext,
} from "../../context/PlayoffContext";
import { deleteInfographic, getPlayoffDetails } from "../../apis/Playoff";
import {
  ChevronLeft,
  ChevronRightOutlined,
  Delete,
  Edit,
} from "@mui/icons-material";
import { Group } from "../../components/Playoff/Group";
// import InfographicDrawer from "../../components/Playoff/InfographicDialog";
import InfographicDialog from "../../components/Playoff/InfographicDialog";
// import { PlayoffProvider } from "../../context/PlayoffContext";
export default function PlayoffView() {
  return (
    <PlayoffProvider>
      <PlayoffViewContent />
    </PlayoffProvider>
  );
}

function PlayoffViewContent() {
  const { id } = useParams();
  //   console.log("Route id:", id);
  const { groups, setPlayoff } = usePlayoffContext();
  const [playoff, setPlayoffData] = useState(null); //   const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  //   const [openInfographicDialog, setOpenInfographicDialog] = useState(false);
  //   const [editInfographic, setEditInfographic] = useState(null);
  const [selectedDeleteInfographic, setSelectedDeleteInfographic] =
    useState(null);
  const [openInfographicDialog, setOpenInfographicDialog] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedInfographic, setSelectedInfographic] = useState(null);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const toggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handleOpenInfographicDialog = () => {
    setSelectedInfographic(null);
    setOpenInfographicDialog(true);
  };
  const handleEditInfographic = (infographic) => {
    setSelectedInfographic(infographic);
    setOpenInfographicDialog(true);
  };
  const handleDeleteInfographic = (infographic) => {
    setSelectedDeleteInfographic(infographic);
    setDeleteDialogOpen(true);
  };
  const handleDelete = async () => {
    try {
      await deleteInfographic(selectedDeleteInfographic.id);

      const data = await getPlayoffDetails(playoff.id);

      setPlayoffData(data);
      setPlayoff(data);

      setDeleteDialogOpen(false);
      setSelectedDeleteInfographic(null);
    } catch (err) {
      console.error(err);
    }
  };
  const handleCloseInfographicDialog = () => {
    setOpenInfographicDialog(false);
  };
  const [currentImages, setCurrentImages] = useState({});
  const handlePrev = (id) => {
    setCurrentImages((prev) => ({
      ...prev,
      [id]: Math.max((prev[id] || 0) - 1, 0),
    }));
  };

  const handleNext = (id, totalImages) => {
    setCurrentImages((prev) => ({
      ...prev,
      [id]: Math.min((prev[id] || 0) + 1, totalImages - 1),
    }));
  };

  const fetchPlayoff = useCallback(async () => {
    setLoading(true);

    try {
      const data = await getPlayoffDetails(id);

      setPlayoffData(data);
      setPlayoff(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [id, setPlayoff]);

  useEffect(() => {
    fetchPlayoff();
  }, [fetchPlayoff]);
  return (
    <>
      {loading && <FullHeightLoader />}

      {playoff && (
        <Grid container justifyContent="center" spacing={3}>
          <Grid item xs={12} md={8}>
            <Typography variant="h6" gutterBottom>
              Title
            </Typography>

            <Typography variant="h4" sx={{ mb: 1 }}>
              {playoff.title}
            </Typography>

            <Typography variant="h6" gutterBottom>
              Description
            </Typography>

            {/* <Typography
              variant="body1"
              sx={{
                whiteSpace: "pre-wrap",
                mb: 4,
              }}
            >
              {playoff.description}
            </Typography> */}
            <Box mt={1} mb={1}>
              <Typography
                variant="body2"
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: expandedDescriptions[playoff.id] ? "unset" : 3,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: expandedDescriptions[playoff.id]
                    ? "normal"
                    : "initial",
                }}
              >
                {playoff.description}
              </Typography>

              {playoff.description && (
                <Button
                  size="small"
                  onClick={() => toggleDescription(playoff.id)}
                  sx={{
                    p: 0,
                    mt: 0.5,
                    minWidth: "auto",
                    textTransform: "none",
                  }}
                >
                  {expandedDescriptions[playoff.id]
                    ? "Show less"
                    : "Show more"}
                </Button>
              )}
            </Box>

            {playoff.prize && (
              <Box sx={{ mb: 4 }}>
                <Typography variant="h6" gutterBottom>
                  Giveaway
                </Typography>

                <Card sx={{ display: "flex" }}>
                  <CardMedia
                    component="img"
                    image={playoff.prize.image}
                    sx={{ width: 150 }}
                  />

                  <CardContent>
                    <Typography variant="h6">{playoff.prize.title}</Typography>

                    <Typography color="text.secondary">
                      {playoff.prize.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            )}

            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" gutterBottom>
                Groups
              </Typography>

              <Grid container spacing={2}>
                {groups.map((group) => (
                  <Group
                    key={group.id}
                    group={group}
                    handleConfirmGroup={() => { }}
                    readOnly
                  />
                ))}
              </Grid>
            </Box>

            <Box sx={{ mt: 4, mb: 4 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Typography variant="h6">Infographics</Typography>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenInfographicDialog}
                >
                  Add Infographic
                </Button>
              </Stack>

              {playoff.infographics?.length > 0 ? (
                <Grid container spacing={2}>
                  {playoff.infographics.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                      <Card>
                        <Box sx={{ position: "relative" }}>
                          <CardMedia
                            component="img"
                            image={
                              item.images[currentImages[item.id] || 0]?.file
                            }
                            sx={{
                              aspectRatio: "4 / 5",
                              objectFit: "cover",
                            }}
                          />

                          {item.images.length > 1 && (
                            <>
                              <IconButton
                                disabled={(currentImages[item.id] || 0) === 0}
                                onClick={() => handlePrev(item.id)}
                                sx={{
                                  position: "absolute",
                                  left: 8,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  bgcolor: "white",
                                }}
                              >
                                <ChevronLeft />
                              </IconButton>

                              <IconButton
                                disabled={
                                  (currentImages[item.id] || 0) ===
                                  item.images.length - 1
                                }
                                onClick={() =>
                                  handleNext(item.id, item.images.length)
                                }
                                sx={{
                                  position: "absolute",
                                  right: 8,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  bgcolor: "white",
                                }}
                              >
                                <ChevronRightOutlined />
                              </IconButton>
                            </>
                          )}
                        </Box>

                        <CardContent>
                          <Typography sx={{ mb: 2 }}>
                            {item.description}
                          </Typography>

                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="flex-start"
                          >
                            <IconButton
                              size="small"
                              onClick={() => handleEditInfographic(item)}
                            >
                              <Edit fontSize="small" />
                            </IconButton>

                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleDeleteInfographic(item)}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </Stack>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography color="text.secondary">
                  No infographics added yet.
                </Typography>
              )}
            </Box>
            {/* </> */}
          </Grid>
        </Grid>
      )}

      <InfographicDialog
        open={openInfographicDialog}
        onClose={handleCloseInfographicDialog}
        playoffId={playoff?.id}
        infographic={selectedInfographic}
        onSuccess={fetchPlayoff}
      />
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Delete Infographic</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this infographic?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>

          <Button color="error" variant="contained" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
